export default [
    {
        zfr:{
            zfr1O :{
                Desc:"Some string paragraph 1111111",
                specs:{
                       chassis:"Tubular Space Frame",
                       Power:"22.11 BHP @9300 rpm",
                       Torque:"21 Nm @6900 rpm",
                       weight:"301 Kg",
                       Bodyworks:"GFRP",
                       Engine:"250 cc Honda CBR 250R",
                       Tyres:'13" Yokohama',
                       
                       ECU:"Standard Wiring Harness",
                       Suspension:"Double Wishbone",
                       Cooling:"Stock Cooling System"

                      },
                
             



            },
            zfr20:{
              Desc:"Some string paragraph  22222",
              specs:{
                chassis:"Tubular Space Frame",
                Power:"22.11 BHP @9300 rpm",
                Torque:"21 Nm @6900 rpm",
                weight:"292 Kg",
                Bodyworks:"GFRP",
                Engine:"250 cc Honda CBR 250R",
                Tyres:'13" Yokohama',
                
                ECU:"Standard Wiring Harness",
                Suspension:"Double Wishbone",
                Cooling:"Stock Cooling System"

               },
              
              
            },
            zfr30:{
              Desc:"Some string paragraph   33333",
              specs:{
                      chassis:"Tubular Space Frame",
                       Power:"22.11 BHP @9300 rpm",
                       Torque:"21 Nm @6900 rpm",
                       weight:"190 Kg",
                       Bodyworks:"CFRP",
                       Engine:"2500 cc Honda CBR 250R",
                       Tyres:'10" Hoosier',
                       
                       ECU:"Custom Built Wiring Harness",
                       Suspension:"Double Wishbone",
                       Cooling:"Self Designed and Fabricated Cooling System"

               },
              
          },
          zfr40:{
              Desc:"Some string paragraph ",
              specs:{
                       chassis:"Tubular Space Frame",
                       Power:"22.11 BHP @9300 rpm",
                       Torque:"21 Nm @6900 rpm",
                       weight:"208 Kg",
                       Bodyworks:"GFRP",
                       Engine:"250 cc Honda CBR 250R",
                       Tyres:'10" Hoosier',
                       
                       ECU:"Custom Built Wiring Harness with Data Acquisation",
                       Suspension:"Double Wishbone",
                       Cooling:"Self Designed and Fabricated Cooling System"

               },
              
          },
          zfr50:{
              Desc:"Some string paragraph   55555",
              specs:{
                chassis:"Tubular Space Frame",
                Power:"22.11 BHP @9300 rpm",
                Torque:"21 Nm @6900 rpm",
                weight:"175 Kg",
                Bodyworks:"CFRP",
                Engine:"390 cc Honda CBR 250R",
                Tyres:'10" Hoosier',
                
                ECU:"Custom Built Wiring Harness with Data Acquisation",
                Suspension:"Double Wishbone",
                Cooling:"Self Designed and Fabricated Cooling System"

               },
             
          }
        }
    }

]